/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react';
import { classNames } from '@/utils';
import { ModalProps } from './types';
import { ButtonIcon } from '../ButtonIcon';

export function Modal({ className, opened, title, onClose, children, size = 'small', footer }: ModalProps) {
  if (!opened) return null;

  return (
    <section className="modal visible">
      <div className="background-overlay" onClick={onClose} />
      <div className={classNames('modal-popup', size, className)}>
        <div className="modal-header">
          <h3>{title}</h3>
          <ButtonIcon variant="close-modal" onClick={onClose}>
            <i className="fa-regular fa-xmark" />
          </ButtonIcon>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </section>
  );
}

Modal.displayName = 'Modal';
